import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import {
  getMCHtml,
  mapScript,
  slightlyDifferent,
} from "./MailingListBlock.utils";
import { InnerBlockContainer } from "../../BaseComponents/Wrappers/InnerBlockContainer/InnerBlockContainer";
import { BlockContainer } from "../../BaseComponents/Wrappers/BlockContainer/BlockContainer";
import { H2 } from "../../BaseComponents/Text";

export const MailingListBlock = ({ Heading }) => {
  const scriptRef = useRef();
  const scriptSrcRef = useRef();

  useEffect(() => {
    if (!scriptSrcRef) mapScript(scriptTmp.current);
    if (!scriptRef) slightlyDifferent(script.current);
  }, []);

  return (
    <BlockContainer>
      <InnerBlockContainer>
        {!!Heading && (
          <H2 textAlign="center" margin="0 0 1rem 0">
            {Heading}
          </H2>
        )}
        <div ref={scriptSrcRef} />
        <div ref={scriptRef} />
        <div dangerouslySetInnerHTML={{ __html: getMCHtml() }}></div>
      </InnerBlockContainer>
    </BlockContainer>
  );
};

MailingListBlock.propTypes = {
  Heading: PropTypes.string,
};
